import {
  IRelativeSchedulingRules,
  TreatmentStepStatus,
} from '@principle-theorem/principle-core/interfaces';
import { ISerialisedDocumentReference } from '@principle-theorem/shared';
import {
  IBigQueryChartedTreatment,
  ISerialisedPricedServiceCodeSummary,
} from '../facts/common';
import {
  IBigQueryFirestoreModel,
  IBigQueryNamedDocument,
  IBigQueryReffable,
  ITimestampedDimension,
} from './common';
import { IBigQueryAssociatedTreatmentCategory } from './appointment';

export interface ITreatmentStepDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    ITimestampedDimension {
  name: string;
  status: TreatmentStepStatus;
  brandRef: ISerialisedDocumentReference;
  patientRef: ISerialisedDocumentReference;
  treatmentPlanRef: ISerialisedDocumentReference;
  practitioner?: IBigQueryNamedDocument;
  invoiceRef?: ISerialisedDocumentReference;
  appointmentRef?: ISerialisedDocumentReference;
  practiceRef?: ISerialisedDocumentReference;
  treatments: IBigQueryStepChartedTreatment[];
  serviceCodes: ISerialisedPricedServiceCodeSummary[];
  treatmentCategory?: IBigQueryAssociatedTreatmentCategory;
  schedulingRules: IRelativeSchedulingRules;
  deleted: boolean;
}

export interface IBigQueryStepChartedTreatment
  extends IBigQueryChartedTreatment {
  practitioner?: IBigQueryNamedDocument;
  serviceCodeSummary: ISerialisedPricedServiceCodeSummary[];
  chartedSurfaceSummary: string[];
  treatmentCategory?: IBigQueryAssociatedTreatmentCategory;
}
